import React, { useContext, useEffect, useRef, useState } from 'react';
import Application from '../../../StateContext/Application.js';
import { apiurl } from '../../../../../path.js';
import * as XLSX from 'xlsx';
import "../BudgetHeadCreation/BudgetHead.css";
import { Cancel32 } from '../../../../../public/LoginImages/importimages';
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext.js';

const ReleasefromFinanceWorkForm = () => {
  const submitLockRef = useRef(false);
  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);
  const { GetBudgetHeadInfo, ReleaseFDUTF, Usermenu } = operation;
  const [loading, setLoading] = useState(false);
  const [AllHeadID, setAllHeadID] = useState([]);
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [GRData, setGRData] = useState([]);
  const [AllGRID, setAllGRID] = useState([]);
  const [AllProposalID, setAllProposalID] = useState([]);
  const [AllWorkDetail, setAllWorkDetail] = useState([]);
  const [AllLimitAllocation, setAllLimitAllocation] = useState([]);
  const [originalLimitAllocatedCost, setOriginalLimitAllocatedCost] = useState(0);

  const [tableData, setTableData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [Indexofediting, setIndexofEditing] = useState(null);
  const [ShowMenu, setShowMenu] = useState(0);

  const [RoleID, setroleID] = useState(null)
  const [data, setData] = useState({
    FinancialYear: '',
    HeadCode: "",
    District: "",
    Taluka: "",
    GRID: "",
    GRNumber: "",
    ProposalID: "",
    WorkName: "",
    LimitAllocatedcost: "0",
    ProposalCost: "",
    ReleaseAmountTillDate: '',
    ReleaseAmount: 0,
    ReleaseDate: null,
    ProjectName: '',
    ProjectID: '',
    BudgetHeadID: '',
    BudgetHeadName: "",
    demandAmount: ""
  });

  console.log("Table data : :", tableData);

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID)
      console.log("sffdsf", roleID)
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔐 HARD LOCK (instant, prevents double click)
    if (submitLockRef.current) return;
    submitLockRef.current = true;

    if (!tableData.length) {
      alert("No entries added to submit.");
      submitLockRef.current = false;
      return;
    }

    // 🔴 STRICT VALIDATION
    for (const row of tableData) {
      if (
        row.LimitAllocatedcost === "0" ||
        row.LimitAllocatedcost === null ||
        row.LimitAllocatedcost === undefined
      ) {
        continue;
      }

      const demand = Number(row.demandAmount || 0);
      const previous = Number(row.PreviousLimitallocatedamount || 0);
      const entered = Number(row.LimitAllocatedcost || 0);
      const exactRequired = demand - previous;

      if (entered !== exactRequired) {
        alert(
          `Invalid Limit Allocation for MHUID ${row.MHUID || ""}\n\n` +
          `Required EXACT amount: ${exactRequired}\n` +
          `Entered amount: ${entered}`
        );
        submitLockRef.current = false;
        return;
      }
    }

    try {
      setLoading(true); // UI lock

      const result = await ReleaseFDUTF(tableData, "Work");

      if (result?.status) {
        alert(result.message);

        // ⛔ keep lock active before reload
        setTimeout(() => {
          window.location.reload();
        }, 300);
      } else {
        alert(result?.message || "Submission failed");
        submitLockRef.current = false;
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
      submitLockRef.current = false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setData({ ...data, ReleaseAmountTillDate: data.ReleaseAmount });
  }, [data.ReleaseAmount])

  // Fetching 
  const FetchData = async () => {
    try {
      let res1 = await GetBudgetHeadInfo('null', "AllHeadCode");
      let res2 = await GetBudgetHeadInfo('null', "AllDistrict");
      let res3 = await GetBudgetHeadInfo('null', "GetAllBudgetEstimationData");
      setAllHeadID(res1);
      setAllDistrict(res2);
      setAllLimitAllocation(res3);
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    FetchData()
    getmenu()
  }, []);

  useEffect(() => {
    if (!RoleID) return;

    setData(prev => ({
      ...prev,
      HeadCode:
        RoleID === 25 || RoleID === 24
          ? "3054-2419(Roads and bridge repair maintenance program)"
          : "2515-1238(MLA Representative)"
    }));
  }, [RoleID]);

  useEffect(() => {
    if (data.District) {
      let res = AllDistrict.filter((item) => item.District_Marathi === data.District && item.ULBNameMarathi &&
        item.ULBNameMarathi.trim() !== "");
      setTalukasofDistrict(res);
    }
  }, [data.District]);


  const GetSpecificGRDatabyTalukaDistrict = async () => {
    try {
      let obj = {
        HID: data.HeadCode,
        PY: data.FinancialYear,
        ZP: data.District,
        Ta: data.Taluka
      };

      let res = await GetBudgetHeadInfo(obj, "GetSpecificGRData");
      setGRData(res);

      let grid = [...new Set(res.map(val => val.GRID))];
      setAllGRID(grid)


      if (Array.isArray(res) && res.length > 0) {

        const formatted = res.map((val, index) => ({
          FinancialYear: data.FinancialYear,
          HeadCode: data.HeadCode,
          District: data.District,
          Taluka: data.Taluka,
          GRID: val.GRID,
          GRNumber: val.GRNumber,
          ProposalID: val.Work_name,
          WorkName: val.WorkOrderName,
          physicalValue: val.physicalValue,
          ProposalCost: val.WORK_ORDER_AMOUNT || "0",
          LimitAllocatedcost: "0",
          ReleaseAmountTillDate: '',
          ReleaseAmount: 0,
          ReleaseDate: data.ReleaseAmount,
          ProjectName: '',
          ProjectID: val.ProposalID,
          BudgetHeadID: '',
          BudgetHeadName: "",
          demandAmount: val.DRAmount || "0",
          MHUID: val.MHUID,
          PreviousLimitallocatedamount: val.LimitAllotedAmount || "0",
          JOB_ID:val.JOB_ID
        }));

        setTableData(prevData => {
          const existingKeys = new Set(
            prevData.map(
              item => `${item.GRID}-${item.ProposalID}-${item.FinancialYear}`
            )
          );

          const newData = formatted.filter(
            item =>
              !existingKeys.has(`${item.GRID}-${item.ProposalID}-${item.FinancialYear}`)
          );

          return [...prevData, ...newData];
        });
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (data.FinancialYear && data.HeadCode && data.District && data.Taluka) {
      setTableData([]); // ✅ CLEAR OLD DATA
      GetSpecificGRDatabyTalukaDistrict();
    }
  }, [data.FinancialYear, data.HeadCode, data.District, data.Taluka]);

  useEffect(() => {
    if (data.FinancialYear && data.HeadCode && data.District && data.Taluka && data.GRID) {
      let res = GRData.filter((item) => item.GRID === data.GRID);
      console.log("Data for Propodal id :: ", res)
      setAllProposalID(res);
    }
  }, [data.GRID]);

  const proposalIDcostsetting = (proposalID) => {
    if (data.FinancialYear && data.HeadCode && data.District && data.Taluka && data.GRID) {
      let res = AllProposalID.filter((item) => item.Work_name === proposalID);
      setData({
        ...data,
        ProposalCost: res[0].ProposalAmount,
        ProposalID: proposalID,
        demandAmount: res[0].DRAmount
      });
    }
  };

  const GetAllWorknamesbyProposalIdGrid = async () => {
    try {
      let obj = {
        PID: data.ProposalID,
        GID: data.GRID
      };

      let res = await GetBudgetHeadInfo(obj, "GetAllWorkDatabyproposalIdGRID");

      if (!res?.status) {
        return alert(res?.message);
      }


      const workDetail = res?.data;
      setAllWorkDetail(workDetail);
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (data.GRID && data.ProposalID) {
      GetAllWorknamesbyProposalIdGrid();
    }
  }, [data.GRID && data.ProposalID]);


  const handleAddToTable = (e) => {
    e.preventDefault();

    if (!data.FinancialYear || !data.HeadCode || !data.District || !data.Taluka || !data.GRID || !data.ProposalID || !data.ReleaseDate) {
      alert("Please fill all required fields.");
      return;
    };

    const isDuplicate = tableData.some(
      (entry) =>
        entry.ProposalID === data.ProposalID &&
        entry.FinancialYear === data.FinancialYear
    );

    if (isDuplicate) {
      alert("This Proposal and Financial Year combination already exists!");
      return;
    }

    setTableData([...tableData, data]);

    setData({
      ...data,
      // FinancialYear: '',
      // HeadCode: "",
      // District: "",
      // Taluka: "",
      // GRID: "",
      ProposalID: "",
      WorkName: "",
      LimitAllocatedcost: "0",
      ProposalCost: "",
      ReleaseAmountTillDate: '',
      ReleaseAmount: 0,
      ReleaseDate: '',
      ProjectName: '',
      ProjectID: '',
      BudgetHeadID: '',
      BudgetHeadName: "",
      demandAmount: ""
    });
  }

  const convertExcelDate = (excelDate) => {
    if (typeof excelDate === 'number') {
      // Excel dates start from Jan 1, 1900
      const date = new Date((excelDate - 25569) * 86400 * 1000);
      return date.toISOString().split('T')[0]; // format as YYYY-MM-DD
    }
    return excelDate; // return as-is if already a string
  };

  const handleFileUpload = (e) => {
    try {
      const file = e.target.files[0];
      if (!file) {
        console.warn("No file selected.");
        return;
      }

      console.log("File selected:", file);
      const reader = new FileReader();

      reader.onload = (evt) => {
        const binaryStr = evt.target.result;

        try {
          const workbook = XLSX.read(binaryStr, { type: 'binary' });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          console.log('Parsed Excel Data:', jsonData);

          const formattedData = jsonData
            .filter(row =>
              row['आर्थिक वर्ष'] &&
              row['जिल्हा'] &&
              row['तालुका'] &&
              row['शासन निर्णय क्रमांक'] &&
              row['प्रस्तावाचे नाव'] &&
              row['दिनांक'] &&
              row['मंजूर रक्कम'] &&
              row['आतापर्यंत वितरीत केलेली रक्कम'] &&
              row['या आदेशान्वये वितरीत करावयाची रक्कम']
            ).
            map(row => ({
              FinancialYear: row['आर्थिक वर्ष'],
              District: row['जिल्हा'],
              Taluka: row['तालुका'],
              GRID: row['शासन निर्णय क्रमांक'],
              ProposalID: row['प्रस्तावाचे नाव'],
              ReleaseDate: convertExcelDate(row['दिनांक']),
              ProposalCost: row['मंजूर रक्कम'],
              ReleaseAmountTillDate: row['आतापर्यंत वितरीत केलेली रक्कम'],
              ReleaseAmount: row['आतापर्यंत वितरीत केलेली रक्कम'],
              LimitAllocatedcost: row['या आदेशान्वये वितरीत करावयाची रक्कम']
            }));

          console.log("Formatted Data:", formattedData);

          // You can now use `formattedData` e.g. store it in state:
          // setData(formattedData);
          setTableData(formattedData)

        } catch (parseErr) {
          console.error("Error parsing Excel file:", parseErr);
        }
      };

      reader.readAsBinaryString(file);
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  const handelchangeTablre = (e) => {
    e.preventDefault();
    const updatedData = [...tableData];
    updatedData[Indexofediting] = editIndex;
    setTableData(updatedData);

    setEditIndex(null);
    setIndexofEditing(null);
  };

  const handleEdit = (e, index) => {
    e.preventDefault();
    setEditIndex({ ...tableData[index] });
    setIndexofEditing(index);
  };

  const handleDelete = (e, index) => {
    e.preventDefault();
    const updated = tableData.filter((_, i) => i !== index);
    setTableData(updated);
  };

  const handleSubmitBulk = async (e) => {
    e.preventDefault();

    // 🔐 HARD LOCK
    if (submitLockRef.current) return;
    submitLockRef.current = true;

    try {
      setLoading(true);

      const result = await ReleaseFDUTF(tableData);

      if (result?.message) {
        alert(result.message);

        setTimeout(() => {
          window.location.reload();
        }, 300);
      } else {
        alert("Bulk release failed");
        submitLockRef.current = false;
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
      submitLockRef.current = false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTableData([]);
  }, [ShowMenu])

  return (
    <>
      <div className="col-12" style={{ height: "90vh", overflowY: "scroll", overflowX: 'hidden', scrollBehavior: "smooth", background: "#EFF3F8" }}>
        <div className="col-12 py-4" style={{ background: "#EFF3F8" }}>
          <div className="col-10 m-auto">
            <div className="row">
            </div>
          </div>
        </div>

        {
          ShowMenu == 0 &&
          (
            <>
              <div className="col-12" style={{ background: "#EFF3F8", paddingBottom: "6vh" }}>
                <div className="col-12 m-auto budgetContainer">
                  <div className="m-auto budgetElement">
                    <form action="">

                      <div className="col-12 elements">
                        <div className="col-6 mb-5">
                          <h4 className='fw-bold' >{t("Limit Allocation (Work Wise)")}</h4>
                        </div>
                        <div className="row">

                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Financial Year")}</label>
                          </div>
                          <div className="elementsPart2">
                            {/* <input type="text" name="FinancialYear" value={data.FinancialYear} className='py-2'  disabled></input> */}
                            <select name="FinancialYear" value={data.FinancialYear} id="" className='py-2' onChange={HandleChangeData} required>
                              <option value="null">{t("Choose Financial Year")}</option>
                              <option value="2024-2025">2024 - 2025</option>
                              <option value="2025-2026">2025 - 2026</option>
                              <option value="2026-2027">2026 - 2027</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1 ">
                            <label className='fw-bold'>{t("Head Name")}</label>
                          </div>
                          <div className="elementsPart2">
                            {/* <select name="HeadCode" value={data.HeadCode} className='py-2' onChange={HandleChangeData} required>
                              <option value="">{t("Choose Head Name")}</option>
                              {
                                AllHeadID &&
                                AllHeadID.map((val, index) => {
                                  return (
                                    <option key={index} value={val.HeadID}>{val.HeadName}</option>
                                  )
                                })
                              }
                            </select> */}
                            <select
                              name="HeadCode"
                              value={data.HeadCode}
                              className="py-2"
                              onChange={HandleChangeData}
                              required
                            >
                              <option value="">{t("Choose Head Name")}</option>

                              {AllHeadID &&
                                AllHeadID
                                  .filter(val =>
                                    RoleID === 25 || RoleID === 24
                                      ? val.HeadName === "3054-2419(Roads and bridge repair maintenance program)"
                                      : val.HeadName === "2515-1238(MLA Representative)"
                                  )
                                  .map(val => (
                                    <option key={val.HeadID} value={val.HeadID}>
                                      {val.HeadName}
                                    </option>
                                  ))
                              }
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Zilla Parishad")}</label>
                          </div>
                          <div className="elementsPart2">
                            <select name="District" value={data.District} className='py-2' onChange={HandleChangeData} required>
                              <option value="">{t("Choose Zilla")}</option>
                              {
                                AllDistrict &&
                                [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
                                  return (
                                    <option key={index} value={district}>{district}</option>
                                  )
                                })
                              }
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Taluka")}</label>
                          </div>
                          <div className="elementsPart2">
                            <select name="Taluka" value={data.Taluka} className='py-2' onChange={HandleChangeData} required>
                              <option value="">{t("Choose Taluka")}</option>
                              {
                                TalukasofDistrict.length > 0 &&
                                TalukasofDistrict.map((val, index) => {
                                  return (
                                    <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
                                  )
                                })
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>



              <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "20px 20px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
                <div className="col-12 text-end">
                  <button
                    className="px-4 py-1 btn fw-bold mb-3"
                    disabled={loading || submitLockRef.current}
                    onClick={handleSubmit}
                    style={{
                      backgroundColor: loading ? "#9ca3af" : "#39B54A",
                      color: "white",
                      borderRadius: "7px",
                      cursor: loading ? "not-allowed" : "pointer",
                      opacity: loading ? 0.7 : 1
                    }}
                  >
                    {loading ? "Submitting..." : t("Submit")}
                  </button>
                </div>

                <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
                  <div>
                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                          <th style={{ width: "8%" }}>{t("Year")}</th>
                          <th style={{ width: "8%" }}>{t("District")}</th>
                          <th style={{ width: "8%" }}>{t("GR Number")}</th>
                          {/* <th style={{ width: "10%" }}>शासन निर्णय क्रमांक</th> */}
                          <th style={{ width: "10%" }}>{t("Approved Work Name")}</th>
                          <th style={{ width: "10%" }}>{t("Work Order Name")}</th>
                          <th style={{ width: "10%" }}>{t("Job ID")}</th>
                          <th style={{ width: "10%" }}>{t("Physical Progress in %")}</th>
                          <th style={{ width: "10%" }}>{t("MHUID Number")}</th>
                          {/* <th style={{ width: "10%" }}>दिनांक</th> */}
                          <th style={{ width: "10%" }}>{t("Approved Work Amount")}</th>
                          <th style={{ width: "10%" }}>{t("Demand Amount")}</th>
                          <th style={{ width: "7%" }}>{t("Limit Allocated Till Date")}</th>
                          {/* <th style={{ width: "12%" }}>आतापर्यंत वितरीत केलेली रक्कम</th> */}
                          <th style={{ width: "14%" }}>{t("Limit Allocated Amount")}</th>
                          {/* <th style={{ width: "10%" }}>Action</th> */}
                        </tr>
                      </thead>


                      <tbody>
                        {(() => {
                          // 1. Apply the filter first
                          const filteredData = tableData.filter(
                            (val) => Number(val.demandAmount) !== Number(val.PreviousLimitallocatedamount)
                          );

                          // 2. Check if the resulting filtered array is empty
                          if (filteredData.length === 0) {
                            return (
                              <tr>
                                <td colSpan="12" style={{ textAlign: "center", padding: "20px" }}>
                                  {t("No data found")}
                                </td>
                              </tr>
                            );
                          }

                          // 3. Map the filtered data if it exists
                          return filteredData.map((val, index) => {
                            const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>
                                <td className='py-2'>{val.FinancialYear}</td>
                                <td className='py-2'>{val.District}</td>
                                <td className='py-2'>{val.GRNumber}</td>
                                <td className='py-2'>{val.ProposalID}</td>
                                <td className='py-2'>{val.WorkName}</td>
                                <td className='py-2'>{val.JOB_ID}</td>
                                <td className='py-2'>{val.physicalValue || "NA"}</td>
                                <td className='py-2'>{val.MHUID || "NA"}</td>
                                <td className='py-2'>{val.ProposalCost}</td>
                                <td className='py-2'>{val.demandAmount}</td>
                                <td className='py-2'>{val.PreviousLimitallocatedamount}</td>
                                <td className='py-2'>
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    pattern="[0-9]*"
                                    placeholder='Enter Value'
                                    value={val.LimitAllocatedcost === "" ? "" : val.LimitAllocatedcost || 0}
                                    onChange={(e) => {
                                      let newVal = e.target.value.replace(/[^0-9.]/g, "");
                                      const maxAllowed = Number(val.demandAmount) - Number(val.PreviousLimitallocatedamount);

                                      if (Number(newVal) > maxAllowed) {
                                        alert(`Limit Allocated Amount cannot be greater than Demand Amount (${maxAllowed})`);
                                        return;
                                      }

                                      setTableData((prev) =>
                                        prev.map((row) =>
                                          // Use a unique ID (like ProjectID or a combined key) rather than 'index' 
                                          // since the filtered index might not match the original array index
                                          row.ProjectID === val.ProjectID && row.demandAmount === val.demandAmount
                                            ? { ...row, LimitAllocatedcost: newVal }
                                            : row
                                        )
                                      );
                                    }}
                                    style={{
                                      width: "90%",
                                      border: "1px solid #ccc",
                                      borderRadius: "5px",
                                      padding: "2px 5px",
                                      textAlign: "right",
                                      backgroundColor: "#fff",
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          });
                        })()}
                      </tbody>


                    </table>
                  </div>
                </div>

              </div>

              {
                (editIndex && ShowMenu == 0) &&
                <div style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0, 0, 0, 0.4)",
                  backdropFilter: "blur(6px)",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  animation: "fadeIn 0.3s ease-in-out",
                }}>
                  <div className="col-6 shadow-lg rounded-4 p-4 bg-white border-0 m-auto">
                    <div className="col-12 m-auto rounded p-4 border border-dark">
                      <form action="">
                        <div className="row">

                          <div className="col-12 my-2">
                            <div className="row">
                              <div className="col-6">
                                <label>{t("Approved Work Name")}</label>
                              </div>

                              <div className="col-6">
                                <input type="text" value={editIndex.ProposalID} disabled />
                              </div>

                            </div>
                          </div>

                          <div className="col-12 my-2">
                            <div className="row">
                              <div className="col-6">
                                <label>{t("Approved Work Amount")}</label>
                              </div>

                              <div className="col-6">
                                <input type="text" value={editIndex.ProposalCost} disabled />
                              </div>

                            </div>
                          </div>

                          <div className="col-12 my-2">
                            <div className="row">
                              <div className="col-6">
                                <label>{t("Demand Amount")}</label>
                              </div>

                              <div className="col-6">
                                <input type="text" value={editIndex.demandAmount} disabled />
                              </div>

                            </div>
                          </div>

                          <div className="col-12 my-2">
                            <div className="row">
                              <div className="col-6">
                                <label>{t("Limit Allocated Amount")}</label>
                              </div>

                              <div className="col-6">
                                <input
                                  type="text"
                                  value={editIndex.LimitAllocatedcost}
                                  onChange={(e) => setEditIndex({
                                    ...editIndex,
                                    LimitAllocatedcost: e.target.value
                                  })} />
                              </div>

                            </div>
                          </div>

                          <div className="col-12 my-4 text-center">
                            <button className='btn btn-success px-5 fw-bold' onClick={(e) => handelchangeTablre(e)}>{t("Submit")}</button>
                          </div>

                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              }
            </>
          )
        }

        {
          ShowMenu == 1 &&
          <div className="col-12" style={{ background: "#EFF3F8", paddingBottom: "6vh", height: "100%" }}>
            <div className="m-auto financeContainer">
              <div className="m-auto budgetElement">
                {loading && (
                  <div
                    style={{
                      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                      display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}>
                    <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                    <style>
                      {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                    </style>
                  </div>
                )}

                <div className="excelContainer m-auto">
                  <div className='col-12 m-auto px-3'>
                    <form >
                      <div className='col-12'>
                        <div className='row'>
                          <div className='col-12'>
                            <label className='fw-bold mb-2' style={{ fontSize: "16px" }}>{t("Upload Excel File")}</label>
                          </div>
                          <div className="col-12">
                            <input
                              type="file"
                              className="form-control py-2"
                              style={{ backgroundColor: 'white', border: '1px solid #ccc' }}
                              accept=".xlsx, .xls"
                              onChange={handleFileUpload}
                            />
                          </div>
                        </div>
                      </div>

                      <p className='my-3 fw-bold' style={{ fontSize: "16px" }}>{t("File Format for Upload")} ::
                        {
                          <a href={`${apiurl}/FinancialReleaseGR/FileFormatForUpload.xlsx`} target='_blank'> {t("File Format for Financial Excel")}
                          </a>}
                      </p>

                      {
                        editIndex &&
                        <div className="col-12">
                          <div className="col-8 m-auto rounded p-4 border border-dark">
                            <form action="">
                              <div className="row">

                                <div className="col-12 my-2">
                                  <div className="row">
                                    <div className="col-6">
                                      <label>प्रस्तावाचे नाव</label>
                                    </div>

                                    <div className="col-6">
                                      <input type="text" value={editIndex.ProposalID} disabled />
                                    </div>

                                  </div>
                                </div>

                                <div className="col-12 my-2">
                                  <div className="row">
                                    <div className="col-6">
                                      <label>या आदेशान्वये वितरीत करावयाची रक्कम</label>
                                    </div>

                                    <div className="col-3">
                                      <input type="text" value={editIndex.LimitAllocatedcost} name='LimitAllocatedcost' onChange={(e) => setEditIndex({ ...editIndex, LimitAllocatedcost: e.target.value })} />
                                    </div>

                                    <div className="col-3 my-auto">
                                      <p className='fw-bold my-auto'>कोटी</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-12 my-4 text-center">
                                  <button className='btn btn-success px-5 fw-bold' onClick={(e) => handelchangeTablre(e)}>{t("Submit")}</button>
                                </div>

                              </div>
                            </form>
                          </div>
                        </div>
                      }

                      {
                        tableData &&
                        tableData.length > 0 &&
                        (
                          <div className="col-12 my-3">
                            <div className="row">
                              <div className="col-12">
                                <div className="tableContainer m-auto">
                                  <table style={{ border: '1px solid green' }}>
                                    <thead>
                                      <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
                                        <th style={{ width: "10%", textAlign: "start" }}>आर्थिक वर्ष</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>जिल्हा</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>तालुका</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>शासन निर्णय क्रमांक</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>प्रस्तावाचे नाव</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>दिनांक</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>मंजूर रक्कम</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>आतापर्यंत वितरीत केलेली रक्कम</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>या आदेशान्वये वितरीत करावयाची रक्कम</th>
                                        <th style={{ width: "10%", textAlign: "start" }}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {
                                        tableData.map((val, index) => {
                                          return (
                                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
                                              <td style={{ textAlign: "start" }}>{val.FinancialYear}</td>
                                              {/* <td style={{ textAlign: "start" }}>{val.HeadName}</td> */}
                                              <td style={{ textAlign: "start" }}>{val.District}</td>
                                              <td style={{ textAlign: "start" }}>{val.Taluka}</td>
                                              <td style={{ textAlign: "start" }}>{val.GRID}</td>
                                              <td style={{ textAlign: "start" }}>{val.ProposalID}</td>
                                              <td style={{ textAlign: "start" }}>{val.ReleaseDate}</td>
                                              <td style={{ textAlign: "start" }}>{val.ProposalCost} CR</td>
                                              <td style={{ textAlign: "start" }}>{val.ReleaseAmountTillDate} CR</td>
                                              {/* <td style={{ textAlign: "start" }}>{val.ReleaseAmount}</td> */}
                                              <td style={{ textAlign: "start" }}>
                                                {
                                                  val.LimitAllocatedcost || 0
                                                } CR
                                              </td>
                                              {/* <td style={{ textAlign: "start" }}>{new Date(val.currentDate).toLocaleString()}</td> */}
                                              <td>
                                                <button className="btn btn-sm btn-primary mx-1" onClick={(e) => handleEdit(e, index)}>{t("Edit")}</button>
                                              </td>
                                            </tr>

                                          )
                                        })
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                            </div>
                          </div>
                        )
                      }
                      <div className='col-12 text-center mt-4'>
                        <button
                          className="btn"
                          disabled={loading || submitLockRef.current}
                          onClick={handleSubmitBulk}
                          style={{
                            backgroundColor: loading ? "#9ca3af" : "#39B54A",
                            color: "white",
                            borderRadius: "7px",
                            cursor: loading ? "not-allowed" : "pointer",
                            opacity: loading ? 0.7 : 1
                          }}
                        >
                          {loading ? "Submitting..." : t("Submit")}
                        </button>
                        <button className='btn btn-danger mx-4'
                          style={{
                            backgroundColor: "#C1272D",
                            color: "white", borderRadius: "7px"
                          }}><img src={Cancel32} style={{ width: '1.2rem', }} onClick={(e) => { e.preventDefault(); window.location.reload() }} /> {t("Cancel")}</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </>
  )
};

export default ReleasefromFinanceWorkForm;